import React from 'react';
import DatePicker from 'react-datepicker';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, triggerSearch } from 'slices/glassSearchSlice';
import { Row, Col, InputGroup, Form, Button } from 'react-bootstrap';
import Totals from './totals-row/Totals';

const Filters = () => {
    const filters = useSelector(s => s.glassSearchFilter);
    const permissions = useSelector(state => state.user.permissions);
    const dispatch = useDispatch();
    const SUPPLIERS = [
        {
            name: 'Padiham',
            value: 51
        },
        {
            name: 'Glass Systems',
            value: 71
        }
    ];
    const allowSupplierSearch = permissions?.some(x => x.pageName === 'GlassDashSupplierChange');
    return (
        <Row className='h-100 align-items-center'>
            <Col xs={8}>
                <Form.Group as={Row}>
                    <Form.Label className='vertical-align-middle' column xs={1}>Date</Form.Label>
                    <Col xs={5}>
                        <InputGroup>
                            <Col xs={5}>
                                <DatePicker
                                    calendarStartDay={1}
                                    id="date-from"
                                    className="form-control text-center"
                                    placeholderText="Select From"
                                    onChange={date => dispatch(setFilters({ ...filters, start: new Date(date).toISOString() }))}
                                    dateFormat={'dd/MM/yyyy'}
                                    selected={filters?.start ? new Date(filters?.start) : new Date()}
                                    isClearable
                                />
                            </Col>
                            <Col xs={1}>
                                <InputGroup.Text>To</InputGroup.Text>
                            </Col>
                            <Col xs={5}>
                                <DatePicker
                                    calendarStartDay={1}
                                    id="date-to"
                                    className="form-control text-center"
                                    placeholderText="Select To"
                                    onChange={date => dispatch(setFilters({ ...filters, end: new Date(date).toISOString() }))}
                                    dateFormat={'dd/MM/yyyy'}
                                    selected={filters?.end ? new Date(filters?.end) : new Date()}
                                    isClearable
                                />
                            </Col>
                        </InputGroup>
                    </Col>
                    {allowSupplierSearch &&
                        <>
                            <Form.Label className='vertical-align-middle' column xs={1}>Supplier</Form.Label>
                            <Col xs={3}>
                                <Form.Select
                                    aria-label="Supplier selection"
                                    value={filters?.supplier}
                                    onChange={e => dispatch(setFilters({ ...filters, supplier: +e.target.value }))}>
                                    {SUPPLIERS.map(x =>
                                        <option key={x.value} value={x.value}>
                                            {x.name}
                                        </option>
                                    )}
                                </Form.Select>
                            </Col>
                        </>
                    }
                    <Col xs={1}><Button onClick={() => dispatch(triggerSearch())}>Search</Button></Col>
                </Form.Group>
            </Col>
            <Col xs={4} className='h-100'>
                <Totals />
            </Col>
        </Row>
    );
}

export default Filters;